import React from 'react'
import { Table, Badge, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconCreditCard } from '@tabler/icons-react'

// Placeholder for Action Menu - currently just visual consistency
const ActionMenu = ({ handleAction, detail }) => {
    return (
        <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
            <Menu.Target>
                <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
                    <IconDotsVertical stroke={1.5} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item
                    leftSection={<IconPencil stroke={1.5} size={14} />}
                    onClick={() => handleAction('edit')}
                    fw='600'
                    fz={11}
                >
                    Edit
                </Menu.Item>
                <Menu.Item
                    leftSection={<IconCreditCard stroke={1.5} size={14} />}
                    onClick={() => handleAction('defaultPayment')}
                    fw='600'
                    fz={11}
                >
                    Default Payment
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}

const TableCountry = ({ label, data, actionMethod }) => {
    const mappingTableHead = (data) => data.map((val, index) => {
        return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
    })

    const mappingDataTable = (data) => data.map((val, index) => {
        return (
            <Table.Tr key={index}>
                <Table.Td>{val.id}</Table.Td>
                <Table.Td>{val.name}</Table.Td>
                <Table.Td>{val.currency}</Table.Td>
                <Table.Td>{val.iso_code_2} / {val.iso_code_3}</Table.Td>
                <Table.Td>
                    <Badge variant="light" w={50} color={val.postcode_required ? 'teal' : 'gray'} tt='capitalize' fw='500'>
                        {val.postcode_required ? 'Yes' : 'No'}
                    </Badge>
                </Table.Td>
                <Table.Td>
                    <Badge variant="light" w={70} color={val.status === 1 ? 'teal' : 'red'} tt='capitalize' fw='500'>
                        {val.status === 1 ? 'Active' : 'Inactive'}
                    </Badge>
                </Table.Td>
                <Table.Td>
                    {val.weight_unit && val.dimension_unit ? `${val.weight_unit} / ${val.dimension_unit}` : '-'}
                </Table.Td>
                <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
            </Table.Tr>
        )
    })

    return (
        <Table.ScrollContainer minWidth={1000} type='native'>
            <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
                <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                    <Table.Tr>
                        {mappingTableHead(label)}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody style={{ verticalAlign: 'top' }}>
                    {mappingDataTable(data)}
                </Table.Tbody>
            </Table>
        </Table.ScrollContainer>
    )
}

export default TableCountry
